angular.module('wbControllers').controller 'FinancialPlanController',
['$scope', '$rootScope', 'plans', '$routeParams', '$location', '$window',
'railsResource', '$interval', 'users',
($scope, $rootScope, plans, $routeParams, $location, $window, $resource, $interval, users) ->
  FinancialPlans = $resource '/financial_plans/:id', { id: '@id' },
    requestReview: { method: 'PUT', url: '/financial_plans/:id/review' }
    completeReview: { method: 'DELETE', url: '/financial_plans/:id/review' }
    cancelReview: { method: 'POST', url: '/financial_plans/:id/review' }

  if $routeParams.id
    if $routeParams.id is 'new'
      $scope.fp = FinancialPlans.create { userId: $routeParams.clientId }, (fp) ->
        $location.replace().path "/financial-plans/#{fp.id}"
    else
      $scope.fp = FinancialPlans.get id: $routeParams.id, (fp) ->
        $scope.loaded = true
        $scope.plan = _.cloneDeep(fp.data)
        $scope.$watch 'plan', debouncedSave, true
        $scope.$watch 'fp.title', debouncedSave, true
      , (error) ->
        $scope.unauthorized = true
        $scope.access = {}
  else
    FinancialPlans.query (plans) ->
      if plans.length > 0
        $location.path("/financial-plans/#{plans[0].id}")
      else
        $location.path("/financial-plans/start")

  return unless $routeParams.id?

  # Remove the unload handler once this scope is destroyed
  $scope.$on '$destroy', -> window.beforeunload = null

  $scope.hasChanges = ->
    return true if $scope.fp.new
    oldData = angular.toJson($scope.fp.data)
    newData = angular.toJson($scope.plan)
    oldData != newData

  $scope.selectedPane = 'charts'

  # Toggle the info pane from chart/notes
  $scope.setSelectedPane = (name) ->
    $scope.selectedPane = name

  $scope.goTo = (plan) ->
    $location.path("/financial-plans/#{plan.id}")

  $scope.new = ->
    $scope.fp = FinancialPlans.create { userId: $scope.fp.user.id }, (fp) ->
      $location.replace().path "/financial-plans/#{fp.id}"

  $scope.copy = ->
    $scope.fp = FinancialPlans.create {
      userId: $scope.fp.user.id,
      copy_existing_plan: $scope.fp,
    }, (fp) ->
      $location.replace().path "/financial-plans/#{fp.id}"

  $scope.delete = ->
    if confirm("This will delete the plan.")
      $scope.fp.$delete()
      if $scope.auth.hasRole('staff')
        $window.location.assign("/app/clients/#{$scope.fp.user.id}")
      else
        $window.location.assign('/app/') # Force a page reload to prevent 404

  $scope.save = ->
    $scope.fp.data = _.cloneDeep($scope.plan)
    $scope.fp.$update()

  $scope.saveChanges = ->
    return unless $scope.plan and $scope.hasChanges() and !$scope.fp.new
    $scope.saving = true
    $scope.fp.data = _.cloneDeep($scope.plan)
    $scope.fp.$update (fp) ->
      $scope.saving = false

  $scope.requestReview = ->
    $scope.fp?.$requestReview()
    if analytics && analytics.track
      analytics.track "Requested Financial Plan Review",
        category: 'User'

  $scope.completeReview = ->
    $scope.fp?.$completeReview({'reviewer_email': users.getCurrentUser().email})

  $scope.cancelReview = ->
    $scope.fp?.$cancelReview()
    if analytics && analytics.track
      analytics.track "Cancelled Financial Plan Review",
        category: 'User'

  $scope.togglePanel = (panel) ->
    $scope.panel = panel

  $scope.editName = ->
    $scope.renaming = true

  $scope.renamePlan = ->
    $scope.renaming = false
    $scope.save()


  debouncedSave = _.debounce $scope.saveChanges, 500

  $scope.$on '$locationChangeStart', $scope.saveChanges
]
